import { InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IReviewsSummary } from "./reviewsAggregate";
import { IReviewWidgetSummaryComponentOption, ReviewWidgetSummaryComponentOption } from "./reviewWidgetSummaryComponentOption";
import { IReviewWidgetSummaryFilterComponentBase, ReviewWidgetSummaryFilterComponentBase } from "./reviewWidgetSummaryFilterComponentBase";

export interface IReviewWidgetSummaryComponent extends IReviewWidgetSummaryFilterComponentBase {
    update: (reviewsSummary: IReviewsSummary) => void;
}

export class ReviewWidgetSummaryComponent extends ReviewWidgetSummaryFilterComponentBase implements IReviewWidgetSummaryComponent {
    public selectedRating: number;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);
    }

    componentOptionFactory(currentHtmlElement: HTMLElement): ReviewWidgetSummaryComponentOption {

        let currentRating = currentHtmlElement.getAttribute(AttributeEnums.ReviewWidgetRatingsOption.ratingsOptionRating);
        let totalReviews = this.getTotalReviewsFromIReviewsSummary();
        let ratingCount = this.getRatingCountFromReviewsSummary(+currentRating);
        let isDisabled = this.getStateForIsDisabledFilterOption(+currentRating);
        let isSelected = this.getStateForIsSelectedFilterOption(+currentRating);
        let optionElement: ReviewWidgetSummaryComponentOption = new ReviewWidgetSummaryComponentOption(currentHtmlElement, isDisabled, isSelected, totalReviews, ratingCount);
        return optionElement;
    }

    getTotalReviewsFromIReviewsSummary():number{
        let totalReviews: number = 0;

        totalReviews += this.reviewsSummary.totalFiveStars;
        totalReviews += this.reviewsSummary.totalFourStars;
        totalReviews += this.reviewsSummary.totalThreeStars;
        totalReviews += this.reviewsSummary.totalTwoStars;
        totalReviews += this.reviewsSummary.totalOneStars;

        return totalReviews;
    }

    getRatingCountFromReviewsSummary(currentRating: number): number {
        if (currentRating === 5) {
            return this.reviewsSummary.totalFiveStars;
        }
        if (currentRating === 4) {
            return this.reviewsSummary.totalFourStars;
        }
        if (currentRating === 3) {
            return this.reviewsSummary.totalThreeStars;
        }
        if (currentRating === 2) {
            return this.reviewsSummary.totalTwoStars;
        }
        if (currentRating === 1) {
            return this.reviewsSummary.totalOneStars;
        }
    }

    setIReviewWidgetSummaryComponentOption(ratingsComponentOption: IReviewWidgetSummaryComponentOption): void {
        ratingsComponentOption.isDisabled = this.getStateForIsDisabledFilterOption(ratingsComponentOption.rating);
        ratingsComponentOption.isSelected = this.getStateForIsSelectedFilterOption(ratingsComponentOption.rating);
        ratingsComponentOption.ratingCount = this.getRatingCountFromReviewsSummary(ratingsComponentOption.rating);
        ratingsComponentOption.totalReviews = this.getTotalReviewsFromIReviewsSummary();
        ratingsComponentOption.update(ratingsComponentOption.isSelected, ratingsComponentOption.isDisabled, ratingsComponentOption.totalReviews, ratingsComponentOption.ratingCount);
    }

    updateIReviewWidgetSummaryComponentOptions(): void {
        this.componentOptions.forEach(ratingsComponentOption => {
            this.setIReviewWidgetSummaryComponentOption(ratingsComponentOption as IReviewWidgetSummaryComponentOption);
        });
    }

    updateSelectedRating(selectedRating: number): void {
        this.writeToSelectedRating(selectedRating);
        this.setSelectedRating();
    }
   
    updateDisplay():void{
        this.updateIReviewWidgetSummaryComponentOptions();
    }

    update(reviewsSummary: IReviewsSummary): void {
        this.updateBase(reviewsSummary);
        this.updateDisplay();
    }
}